import React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomTabInfo, TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { useSelector } from 'editor/src/store/hooks';

import Tab from 'editor/src/component/DesktopSidebar/Tabs/Tab/index';
import IconTextLibrary from 'editor/src/component/Icon/IconTextLibrary';

import { DEFAULT_TEXT_LIBRARY_TITLE_KEY } from '../../../TabContents/TextLibraryTabContent/constants';

interface Props {
  pluginName?: string;
  customTabInfo?: CustomTabInfo;
}

function TextLibraryTab({ pluginName, customTabInfo }: Props) {
  const { t } = useTranslation();
  const title = useSelector((state) => state.editorModules.textLibrary.title);
  const hasEntries = useSelector((state) => state.editorModules.textLibrary.entries.length > 0);

  // the tab is normally added only while there are entries, but a host may also list it in its own tabs
  if (!hasEntries) {
    return null;
  }

  return (
    <Tab
      key={TAB_NAMES.TEXT_LIBRARY}
      name={TAB_NAMES.TEXT_LIBRARY}
      title={title || t(DEFAULT_TEXT_LIBRARY_TITLE_KEY)}
      icon={<IconTextLibrary />}
      pluginName={pluginName}
      customTabInfo={customTabInfo}
    />
  );
}

export default React.memo(TextLibraryTab);
